import { Table } from "react-bootstrap";
import TablePaginationBar from "../components/TablePaginationBar";
import { config } from "../config/config";
import { getFutureSelfQuestions } from "../config/url";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useFetchData from "../hooks/useFetchData";
import { useLocation } from "react-router-dom";

const FutureSelfListview = () => {
  const user = useSelector((state) => state?.user);
  const navigate = useNavigate();
  const location = useLocation();
  const journey = location.state?.journey;

  const [currentPage, setCurrentPage] = useState(1);
  const [videos, setVideos] = useState([]);
  const [currentVideos, setCurrentVideos] = useState([]);
  const [videosPerPage] = useState(10);

  const businessId = user.user?.businessId;
  const businessIdentifier = user.user?.businessIdentifier;

  const response = useFetchData(
    `${getFutureSelfQuestions}?businessId=${businessId}&businessIdentifier=${businessIdentifier}&journeyId=${journey?.id}`,
    config
  );  

  useEffect(() => {
    if (response?.data?.length > 0) setVideos(response?.data);
  }, [response]);

  useEffect(() => {
    if (videos.length > 0) {
      const indexOfLastVideo = currentPage * videosPerPage;
      const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
      setCurrentVideos(videos.slice(indexOfFirstVideo, indexOfLastVideo));
    }
  }, [currentPage, videos, videosPerPage]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const isLoading = response === null;

  return (
    <div className="container">
      <div className="bg-white rounded shadow-sm">
        <div className="app-page-toolbar">
          <h2 className="app-page-title">Future Self Questionnaire</h2>
          <div className="app-page-toolbar-filters">
          <button
            className="app-filter-action-btn"
            onClick={() =>
              navigate("/future-self-questionnaire/add", {
                state: { journey }
              })
            }
          >
            Add New
          </button>
          </div>
        </div>

        {isLoading ? (
          <div className="text-center p-4">Loading Questionnaire...</div>
        ) : videos.length === 0 ? (
          <div className="text-center p-4">No Exercises available.</div>
        ) : (
          <>
            <Table
              className="mb-0"
              hover
              responsive
              style={{ borderCollapse: "collapse", borderSpacing: 0 }}
            >
              <thead
                style={{
                  backgroundColor: "#064260",
                  color: "white",
                  height: "50px",
                  textAlign: "center",
                }}
              >
                
                <tr>
                  <th>ID</th>
                  <th>Exercise</th>
                  <th style={{width: "160px"}}>Action</th>
                </tr>
              </thead>
              <tbody
                style={{
                  color: "#575757",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                {currentVideos.map((video, index) => (
                  <tr key={video.id} style={{ backgroundColor: "white" }}>
                    <td style={{verticalAlign: "middle"}}>{(index + 1 + (currentPage - 1) * videosPerPage)
                        .toString()
                        .padStart(4, "0")}</td>
                    <td style={{verticalAlign: "middle"}}>{video.exercise}</td>
                    <td style={{width: "160px"}} className="text-center">
                      <button
                        className="app-view-btn"
                        onClick={() =>
                          navigate(`/future-self-questionnaire/${video.id}`, {
                            state: { video },
                          })
                        }
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <TablePaginationBar
              currentPage={currentPage}
              totalItems={videos.length}
              rowsPerPage={videosPerPage}
              onPageChange={paginate}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default FutureSelfListview;
